module.exports = __webpack_public_path__ + "img/p9.37cb9de7.png";